var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "dialog-base",
    {
      attrs: {
        visible: _vm.visible,
        title: _vm.dialogTitle,
        size: "xl",
        "show-confirm": false,
        "show-cancel": false,
        "use-panel": false,
        top: "2vh",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
      scopedSlots: _vm._u([
        {
          key: "footer",
          fn: function () {
            return [
              _c(
                "div",
                { staticClass: "sk-dialog-footer" },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "ipd-btn-primary",
                      attrs: {
                        type: "primary",
                        size: "medium",
                        loading: _vm.loadingPayment,
                      },
                      on: { click: _vm.handleSubmitPayment },
                    },
                    [
                      _c("i", { staticClass: "el-icon-circle-check" }),
                      _c("span", [_vm._v("Thanh toán")]),
                    ]
                  ),
                  _vm.checkPermission(["electronic-invoice-create-draft"])
                    ? _c(
                        "el-button",
                        {
                          staticClass: "ipd-btn-warning-plain",
                          attrs: { type: "warning", plain: "", size: "medium" },
                          on: { click: _vm.handleCreateElectronicInvoice },
                        },
                        [
                          _c("i", { staticClass: "el-icon-document" }),
                          _c("span", [_vm._v("Lập HĐ điện tử")]),
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "el-button",
                    {
                      staticClass: "ipd-btn-success-plain",
                      attrs: {
                        type: "success",
                        plain: "",
                        size: "medium",
                        loading: _vm.loadingPrint,
                      },
                      on: { click: _vm.handlePrintReceipt },
                    },
                    [
                      _c("i", { staticClass: "el-icon-printer" }),
                      _c("span", [_vm._v("In phiếu thu")]),
                    ]
                  ),
                  _c(
                    "el-button",
                    {
                      staticClass: "ipd-btn-close",
                      attrs: { type: "info", plain: "", size: "medium" },
                      on: { click: _vm.handleClose },
                    },
                    [
                      _c("i", { staticClass: "el-icon-circle-close" }),
                      _c("span", [_vm._v("Đóng")]),
                    ]
                  ),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c("div", { staticClass: "ipd-student-card mb-4" }, [
        _c("div", { staticClass: "ipd-student-profile-section" }, [
          _c("div", { staticClass: "ipd-student-profile" }, [
            _c("div", { staticClass: "ipd-student-avatar" }, [
              _c("i", { staticClass: "el-icon-user" }),
            ]),
            _c("div", { staticClass: "ipd-student-meta" }, [
              _c("h3", { staticClass: "ipd-student-name" }, [
                _vm._v(_vm._s(_vm.invoiceData.fullName || "Đang tải...")),
              ]),
              _c(
                "div",
                { staticClass: "ipd-student-badges" },
                [
                  _c("span", { staticClass: "ipd-badge ipd-badge--code" }, [
                    _vm._v(
                      "Mã HS: " + _vm._s(_vm.invoiceData.studentCode || "—")
                    ),
                  ]),
                  _c(
                    "el-tag",
                    {
                      staticClass: "ipd-status-tag",
                      attrs: {
                        type: _vm.statusTagType(_vm.invoiceData.status),
                        size: "small",
                        effect: "dark",
                      },
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.statusLabel(_vm.invoiceData.status)) +
                          "\n            "
                      ),
                    ]
                  ),
                  _c(
                    "el-tag",
                    {
                      staticClass: "ipd-status-tag",
                      attrs: {
                        type: _vm.invoiceData.onlinePaymentStatus
                          ? "success"
                          : "info",
                        size: "small",
                        effect: "light",
                      },
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm.invoiceData.onlinePaymentStatus
                              ? "Đã thanh toán Online"
                              : "Chưa thanh toán Online"
                          ) +
                          "\n            "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
          ]),
          _c("div", { staticClass: "ipd-student-info-grid" }, [
            _c("div", { staticClass: "ipd-info-item" }, [
              _c("span", { staticClass: "ipd-info-label" }, [
                _vm._v("Mã phiếu thu"),
              ]),
              _c("span", { staticClass: "ipd-info-value" }, [
                _vm._v(_vm._s(_vm.invoiceData.invoiceCode || "—")),
              ]),
            ]),
            _c("div", { staticClass: "ipd-info-item" }, [
              _c("span", { staticClass: "ipd-info-label" }, [
                _vm._v("Kỳ thu / Đợt"),
              ]),
              _c("span", { staticClass: "ipd-info-value" }, [
                _vm._v(
                  "Tháng " +
                    _vm._s(_vm.invoiceData.month) +
                    "/" +
                    _vm._s(_vm.invoiceData.year) +
                    " — Đợt " +
                    _vm._s(_vm.invoiceData.turn)
                ),
              ]),
            ]),
          ]),
        ]),
        _vm.urlOnlinePayment
          ? _c("div", { staticClass: "ipd-header-qr-section" }, [
              _c("span", { staticClass: "ipd-header-qr-label" }, [
                _vm._v("Thanh toán trực tuyến"),
              ]),
              _c(
                "div",
                { staticClass: "ipd-header-qr-wrapper" },
                [
                  _c(
                    "el-image",
                    {
                      staticClass: "ipd-header-qr-image",
                      attrs: {
                        src: _vm.urlOnlinePayment,
                        "preview-src-list": [_vm.urlOnlinePayment],
                        fit: "contain",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "ipd-qr-image-error",
                          attrs: { slot: "error" },
                          slot: "error",
                        },
                        [_c("i", { staticClass: "el-icon-picture-outline" })]
                      ),
                    ]
                  ),
                ],
                1
              ),
            ])
          : _vm._e(),
      ]),
      _c("div", { staticClass: "ipd-calc-total" }, [
        _c(
          "div",
          { staticClass: "ipd-col-settings" },
          [
            _c(
              "el-popover",
              {
                attrs: {
                  placement: "bottom-start",
                  width: "200",
                  trigger: "click",
                },
              },
              [
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "flex-direction": "column",
                      gap: "8px",
                    },
                  },
                  [
                    _c(
                      "el-checkbox",
                      {
                        model: {
                          value: _vm.visibleColumns.stt,
                          callback: function ($$v) {
                            _vm.$set(_vm.visibleColumns, "stt", $$v)
                          },
                          expression: "visibleColumns.stt",
                        },
                      },
                      [_vm._v("STT")]
                    ),
                    _c(
                      "el-checkbox",
                      {
                        model: {
                          value: _vm.visibleColumns.revenueName,
                          callback: function ($$v) {
                            _vm.$set(_vm.visibleColumns, "revenueName", $$v)
                          },
                          expression: "visibleColumns.revenueName",
                        },
                      },
                      [_vm._v("Tên khoản thu")]
                    ),
                    _c(
                      "el-checkbox",
                      {
                        model: {
                          value: _vm.visibleColumns.issuingElectronicInvoices,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.visibleColumns,
                              "issuingElectronicInvoices",
                              $$v
                            )
                          },
                          expression:
                            "visibleColumns.issuingElectronicInvoices",
                        },
                      },
                      [_vm._v("HĐĐT")]
                    ),
                    _c(
                      "el-checkbox",
                      {
                        model: {
                          value: _vm.visibleColumns.unit,
                          callback: function ($$v) {
                            _vm.$set(_vm.visibleColumns, "unit", $$v)
                          },
                          expression: "visibleColumns.unit",
                        },
                      },
                      [_vm._v("Đơn vị")]
                    ),
                    _c(
                      "el-checkbox",
                      {
                        model: {
                          value: _vm.visibleColumns.quantity,
                          callback: function ($$v) {
                            _vm.$set(_vm.visibleColumns, "quantity", $$v)
                          },
                          expression: "visibleColumns.quantity",
                        },
                      },
                      [_vm._v("Số lượng")]
                    ),
                    _c(
                      "el-checkbox",
                      {
                        model: {
                          value: _vm.visibleColumns.price,
                          callback: function ($$v) {
                            _vm.$set(_vm.visibleColumns, "price", $$v)
                          },
                          expression: "visibleColumns.price",
                        },
                      },
                      [_vm._v("Đơn giá")]
                    ),
                    _c(
                      "el-checkbox",
                      {
                        model: {
                          value: _vm.visibleColumns.taxPercentage,
                          callback: function ($$v) {
                            _vm.$set(_vm.visibleColumns, "taxPercentage", $$v)
                          },
                          expression: "visibleColumns.taxPercentage",
                        },
                      },
                      [_vm._v("Thuế")]
                    ),
                    _c(
                      "el-checkbox",
                      {
                        model: {
                          value: _vm.visibleColumns.discount,
                          callback: function ($$v) {
                            _vm.$set(_vm.visibleColumns, "discount", $$v)
                          },
                          expression: "visibleColumns.discount",
                        },
                      },
                      [_vm._v("Giảm giá")]
                    ),
                    _c(
                      "el-checkbox",
                      {
                        model: {
                          value: _vm.visibleColumns.amount,
                          callback: function ($$v) {
                            _vm.$set(_vm.visibleColumns, "amount", $$v)
                          },
                          expression: "visibleColumns.amount",
                        },
                      },
                      [_vm._v("Thành tiền")]
                    ),
                    _c(
                      "el-checkbox",
                      {
                        model: {
                          value: _vm.visibleColumns.description,
                          callback: function ($$v) {
                            _vm.$set(_vm.visibleColumns, "description", $$v)
                          },
                          expression: "visibleColumns.description",
                        },
                      },
                      [_vm._v("Ghi chú")]
                    ),
                    _c(
                      "el-checkbox",
                      {
                        model: {
                          value: _vm.visibleColumns.calculate,
                          callback: function ($$v) {
                            _vm.$set(_vm.visibleColumns, "calculate", $$v)
                          },
                          expression: "visibleColumns.calculate",
                        },
                      },
                      [_vm._v("Tính toán")]
                    ),
                  ],
                  1
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "ipd-settings-btn",
                    attrs: {
                      slot: "reference",
                      type: "primary",
                      plain: "",
                      icon: "el-icon-setting",
                      size: "small",
                    },
                    slot: "reference",
                  },
                  [_vm._v("Thiết lập cột")]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c("div", [
          _c("span", [_vm._v("Số tiền tính toán: ")]),
          _vm.moneyCheckTotal === 0
            ? _c(
                "span",
                { staticClass: "ipd-calc-value ipd-calc-value--zero" },
                [_vm._v("0")]
              )
            : _c("span", { staticClass: "ipd-calc-value" }, [
                _vm._v(_vm._s(_vm._f("formatCurrency")(_vm.moneyCheckTotal))),
              ]),
        ]),
      ]),
      _c(
        "el-table",
        {
          ref: "detailTable",
          staticClass: "sk-table ipd-detail-table",
          attrs: {
            data: _vm.flattenedDetails,
            border: "",
            "highlight-current-row": "",
            "empty-text": "Không có khoản thu",
            "max-height": 320,
            "cell-style": _vm.cellStyleMethod,
            "row-class-name": _vm.tableRowClassName,
            "row-key": "rowKey",
          },
          on: { "selection-change": _vm.handleSelectionChange },
        },
        [
          _c("el-table-column", {
            attrs: { type: "selection", width: "55", align: "center" },
          }),
          _vm.visibleColumns.stt
            ? _c("el-table-column", {
                attrs: { label: "STT", width: "60", align: "center" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c(
                            "span",
                            { class: { "ipd-child-index": row._isChild } },
                            [_vm._v(_vm._s(row._displayIndex))]
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  2109630847
                ),
              })
            : _vm._e(),
          _vm.visibleColumns.revenueName
            ? _c("el-table-column", {
                attrs: {
                  label: "Tên khoản thu",
                  "min-width": "200",
                  align: "left",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c(
                            "div",
                            {
                              staticClass: "ipd-name-cell",
                              style: {
                                paddingLeft: `${(row._depth || 0) * 24}px`,
                              },
                            },
                            [
                              row._hasChildren
                                ? _c(
                                    "el-button",
                                    {
                                      staticClass: "ipd-toggle-btn",
                                      attrs: { type: "text", size: "mini" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.toggleExpand(
                                            row._parentIdx
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        class: _vm.expandedMap[row._parentIdx]
                                          ? "el-icon-arrow-down"
                                          : "el-icon-arrow-right",
                                      }),
                                    ]
                                  )
                                : _vm._e(),
                              _c(
                                "span",
                                {
                                  class: {
                                    "ipd-parent-name": !row._isChild,
                                    "ipd-child-name": row._isChild,
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(row.revenueName) +
                                      "\n          "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  558459483
                ),
              })
            : _vm._e(),
          _vm.visibleColumns.issuingElectronicInvoices
            ? _c("el-table-column", {
                attrs: { label: "HĐĐT", width: "70", align: "center" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c("el-checkbox", {
                            attrs: { disabled: row._isChild },
                            model: {
                              value: row.issuingElectronicInvoices,
                              callback: function ($$v) {
                                _vm.$set(row, "issuingElectronicInvoices", $$v)
                              },
                              expression: "row.issuingElectronicInvoices",
                            },
                          }),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  2535378531
                ),
              })
            : _vm._e(),
          _vm.visibleColumns.unit
            ? _c("el-table-column", {
                attrs: {
                  label: "Đơn vị",
                  prop: "unit",
                  width: "90",
                  align: "center",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [_c("span", [_vm._v(_vm._s(row.unit || "—"))])]
                      },
                    },
                  ],
                  null,
                  false,
                  3886586390
                ),
              })
            : _vm._e(),
          _vm.visibleColumns.quantity
            ? _c("el-table-column", {
                attrs: { label: "Số lượng", width: "90", align: "center" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c("span", [
                            _vm._v(_vm._s(_vm.formatQuantity(row.quantity))),
                          ]),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  4183977382
                ),
              })
            : _vm._e(),
          _vm.visibleColumns.price
            ? _c("el-table-column", {
                attrs: { label: "Đơn giá", width: "140", align: "right" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c("span", [
                            _vm._v(_vm._s(_vm._f("formatCurrency")(row.price))),
                          ]),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  2330372116
                ),
              })
            : _vm._e(),
          _vm.visibleColumns.taxPercentage
            ? _c("el-table-column", {
                attrs: { label: "Thuế", "min-width": "120", align: "center" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c("span", [
                            _vm._v(_vm._s(_vm.formatTax(row.taxPercentage))),
                          ]),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  1573492222
                ),
              })
            : _vm._e(),
          _vm.visibleColumns.discount
            ? _c("el-table-column", {
                attrs: { label: "Giảm giá", width: "130", align: "right" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          row.discount
                            ? _c(
                                "span",
                                {
                                  class:
                                    row.discountType === "PERCENT" ? "" : "",
                                },
                                [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(
                                        _vm._f("formatCurrency")(
                                          row.discountNumber
                                        )
                                      ) +
                                      "\n          "
                                  ),
                                  row.discountType === "PERCENT"
                                    ? _c(
                                        "span",
                                        { staticClass: "ipd-text-muted" },
                                        [_vm._v(" (%)")]
                                      )
                                    : _vm._e(),
                                ]
                              )
                            : _c("span", { staticClass: "ipd-text-muted" }, [
                                _vm._v("—"),
                              ]),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  2545065890
                ),
              })
            : _vm._e(),
          _vm.visibleColumns.amount
            ? _c("el-table-column", {
                attrs: { label: "Thành tiền", width: "140", align: "right" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c("span", { staticClass: "ipd-money--bold" }, [
                            _vm._v(
                              _vm._s(_vm._f("formatCurrency")(row.amount))
                            ),
                          ]),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  2147539222
                ),
              })
            : _vm._e(),
          _vm.visibleColumns.description
            ? _c("el-table-column", {
                attrs: {
                  label: "Ghi chú",
                  "min-width": "180",
                  align: "left",
                  "class-name": "ipd-text-left",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          row.description
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "ipd-desc-text",
                                      class: {
                                        "ipd-desc-clamped":
                                          !_vm.expandedDescMap[row.rowKey],
                                        "ipd-desc-expanded":
                                          _vm.expandedDescMap[row.rowKey],
                                      },
                                      attrs: {
                                        title: !_vm.expandedDescMap[row.rowKey]
                                          ? row.description
                                          : "",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(row.description.trim()) +
                                          "\n          "
                                      ),
                                    ]
                                  ),
                                  row.description.length > 60 &&
                                  !_vm.expandedDescMap[row.rowKey]
                                    ? _c(
                                        "el-button",
                                        {
                                          staticClass: "ipd-btn-more",
                                          attrs: { type: "text", size: "mini" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.$set(
                                                _vm.expandedDescMap,
                                                row.rowKey,
                                                true
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n            Xem thêm\n          "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  row.description.length > 60 &&
                                  _vm.expandedDescMap[row.rowKey]
                                    ? _c(
                                        "el-button",
                                        {
                                          staticClass: "ipd-btn-more",
                                          attrs: { type: "text", size: "mini" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.$set(
                                                _vm.expandedDescMap,
                                                row.rowKey,
                                                false
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n            Thu gọn\n          "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              )
                            : _c("span", { staticClass: "ipd-text-muted" }, [
                                _vm._v("—"),
                              ]),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  35656391
                ),
              })
            : _vm._e(),
          _vm.visibleColumns.calculate
            ? _c(
                "el-table-column",
                {
                  attrs: { fixed: "right", align: "center", width: "100" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            !row._isChild
                              ? _c("el-checkbox", {
                                  on: {
                                    change: function ($event) {
                                      return _vm.changeCheckbox(row)
                                    },
                                  },
                                  model: {
                                    value: row._checked,
                                    callback: function ($$v) {
                                      _vm.$set(row, "_checked", $$v)
                                    },
                                    expression: "row._checked",
                                  },
                                })
                              : _vm._e(),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    2440081975
                  ),
                },
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [
                      _c("div", [_vm._v("Tính toán")]),
                      _c("el-checkbox", {
                        on: { change: _vm.changeAllCheckbox },
                        model: {
                          value: _vm.checkAll,
                          callback: function ($$v) {
                            _vm.checkAll = $$v
                          },
                          expression: "checkAll",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                2
              )
            : _vm._e(),
        ],
        1
      ),
      _vm.checkPermission([
        "electronic-invoice-create-issued",
        "electronic-invoice-create-draft",
      ])
        ? _c("div", { staticClass: "ipd-invoice-banner" }, [
            _c("div", { staticClass: "ipd-invoice-banner-icon" }, [
              _c("i", { staticClass: "el-icon-warning-outline" }),
            ]),
            _c("div", { staticClass: "ipd-invoice-banner-body" }, [
              _c("h4", { staticClass: "ipd-invoice-banner-title" }, [
                _vm._v("Lưu ý về Hóa đơn điện tử (HĐĐT):"),
              ]),
              _c("div", { staticClass: "ipd-invoice-banner-text" }, [
                _c("p", [
                  _vm._v("\n          1. Chức năng "),
                  _c("strong", [
                    _vm._v("Tự động lập hóa đơn nháp trên Onekids"),
                  ]),
                  _vm._v(" chỉ được khởi tạo cho những "),
                  _c("strong", [_vm._v("khoản chính")]),
                  _vm._v(
                    " đã được đăng ký khai báo hóa đơn điện tử.\n        "
                  ),
                ]),
                _c("p", { staticStyle: { "margin-top": "4px" } }, [
                  _vm._v(
                    "\n          2. Nếu chưa đăng ký tự động, bạn có thể lập thủ công bằng cách sử dụng nút "
                  ),
                  _c("strong", [_vm._v("Lập HĐ điện tử")]),
                  _vm._v(
                    " phía dưới. Những khoản được tích chọn sẽ được chuyển sang hóa đơn điện tử (lưu ý thực hiện "
                  ),
                  _c("strong", [_vm._v("khai báo thuế")]),
                  _vm._v(" đầy đủ cho các khoản đó).\n        "),
                ]),
              ]),
            ]),
          ])
        : _vm._e(),
      _c(
        "div",
        { staticClass: "ipd-payment-area" },
        [
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c("el-col", { attrs: { span: 7 } }, [
                _c("div", { staticClass: "ipd-summary-cards" }, [
                  _c(
                    "div",
                    {
                      staticClass: "ipd-summary-card",
                      class:
                        _vm.invoiceData.beforeMoney < 0
                          ? "ipd-card--danger"
                          : _vm.invoiceData.beforeMoney > 0
                          ? "ipd-card--success"
                          : "ipd-card--neutral",
                    },
                    [
                      _c("div", { staticClass: "ipd-card-left" }, [
                        _c("div", { staticClass: "ipd-card-icon" }, [
                          _c("i", {
                            class:
                              _vm.invoiceData.beforeMoney < 0
                                ? "el-icon-info"
                                : "el-icon-circle-check",
                          }),
                        ]),
                        _c("span", { staticClass: "ipd-card-label" }, [
                          _vm._v(
                            _vm._s(
                              _vm.invoiceData.beforeMoney >= 0
                                ? "Thừa phiếu thu trước"
                                : "Thiếu phiếu thu trước"
                            )
                          ),
                        ]),
                      ]),
                      _c(
                        "span",
                        { staticClass: "ipd-card-value" },
                        [
                          _vm.invoiceData.beforeMoney === 0
                            ? [_vm._v("0 đ")]
                            : [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("formatCurrency")(
                                      Math.abs(_vm.invoiceData.beforeMoney)
                                    )
                                  )
                                ),
                              ],
                        ],
                        2
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "ipd-summary-card ipd-card--primary" },
                    [
                      _c("div", { staticClass: "ipd-card-left" }, [
                        _c("div", { staticClass: "ipd-card-icon" }, [
                          _c("i", { staticClass: "el-icon-document" }),
                        ]),
                        _c("span", { staticClass: "ipd-card-label" }, [
                          _vm._v("Tổng tiền phiếu thu"),
                        ]),
                      ]),
                      _c(
                        "span",
                        { staticClass: "ipd-card-value" },
                        [
                          _vm.invoiceData.sumMoney === 0
                            ? [_vm._v("0 đ")]
                            : [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("formatCurrency")(
                                      _vm.invoiceData.sumMoney
                                    )
                                  )
                                ),
                              ],
                        ],
                        2
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "ipd-summary-card ipd-card--success-light" },
                    [
                      _c("div", { staticClass: "ipd-card-left" }, [
                        _c("div", { staticClass: "ipd-card-icon" }, [
                          _c("i", { staticClass: "el-icon-circle-check" }),
                        ]),
                        _c("span", { staticClass: "ipd-card-label" }, [
                          _vm._v("Tổng tiền đã đóng"),
                        ]),
                      ]),
                      _c(
                        "span",
                        { staticClass: "ipd-card-value" },
                        [
                          _vm.invoiceData.collectedMoney === 0
                            ? [_vm._v("0 đ")]
                            : [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("formatCurrency")(
                                      _vm.invoiceData.collectedMoney
                                    )
                                  )
                                ),
                              ],
                        ],
                        2
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "ipd-summary-card",
                      class:
                        _vm.afterMoney < 0
                          ? "ipd-card--warning-dark"
                          : "ipd-card--success-dark",
                    },
                    [
                      _c("div", { staticClass: "ipd-card-left" }, [
                        _c("div", { staticClass: "ipd-card-icon" }, [
                          _c("i", { staticClass: "el-icon-wallet" }),
                        ]),
                        _c("span", { staticClass: "ipd-card-label" }, [
                          _vm._v(
                            _vm._s(
                              _vm.afterMoney >= 0
                                ? "Còn dư được nhận"
                                : "Còn lại phải đóng"
                            )
                          ),
                        ]),
                      ]),
                      _c(
                        "span",
                        { staticClass: "ipd-card-value" },
                        [
                          _vm.afterMoney === 0
                            ? [_vm._v("0 đ")]
                            : [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("formatCurrency")(
                                      Math.abs(_vm.afterMoney)
                                    )
                                  )
                                ),
                              ],
                        ],
                        2
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "ipd-summary-card ipd-card--info" },
                    [
                      _c("div", { staticClass: "ipd-card-left" }, [
                        _c("div", { staticClass: "ipd-card-icon" }, [
                          _c("i", { staticClass: "el-icon-edit" }),
                        ]),
                        _c("span", { staticClass: "ipd-card-label" }, [
                          _vm._v("Tổng tiền đang nhập"),
                        ]),
                      ]),
                      _c(
                        "span",
                        { staticClass: "ipd-card-value" },
                        [
                          _vm.totalMoneyInput === 0
                            ? [_vm._v("0 đ")]
                            : [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("formatCurrency")(
                                      _vm.totalMoneyInput
                                    )
                                  )
                                ),
                              ],
                        ],
                        2
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "ipd-summary-card",
                      class:
                        _vm.afterMoneyThisMonth < 0
                          ? "ipd-card--danger"
                          : _vm.afterMoneyThisMonth > 0
                          ? "ipd-card--highlight"
                          : "ipd-card--neutral",
                    },
                    [
                      _c("div", { staticClass: "ipd-card-left" }, [
                        _c("div", { staticClass: "ipd-card-icon" }, [
                          _c("i", { staticClass: "el-icon-money" }),
                        ]),
                        _c("span", { staticClass: "ipd-card-label" }, [
                          _vm._v(
                            _vm._s(
                              _vm.afterMoneyThisMonth >= 0
                                ? "Số tiền thừa"
                                : "Số tiền còn thiếu"
                            )
                          ),
                        ]),
                      ]),
                      _c(
                        "span",
                        { staticClass: "ipd-card-value" },
                        [
                          _vm.afterMoneyThisMonth === 0
                            ? [_vm._v("0 đ")]
                            : [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("formatCurrency")(
                                      Math.abs(_vm.afterMoneyThisMonth)
                                    )
                                  )
                                ),
                              ],
                        ],
                        2
                      ),
                    ]
                  ),
                ]),
              ]),
              _c(
                "el-col",
                { attrs: { span: 17 } },
                [
                  _c(
                    "el-form",
                    {
                      ref: "paymentForm",
                      attrs: {
                        model: _vm.paymentData,
                        rules: _vm.paymentRules,
                        "label-width": "155px",
                        "label-position": "left",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "ipd-form-row" },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "ipd-form-item-half",
                              attrs: { label: "Tiền mặt", prop: "cashMoney" },
                            },
                            [
                              _c("el-currency-input", {
                                attrs: {
                                  options: _vm.currencyOption,
                                  placeholder: "Nhập tiền mặt",
                                },
                                model: {
                                  value: _vm.cashMoney,
                                  callback: function ($$v) {
                                    _vm.cashMoney = $$v
                                  },
                                  expression: "cashMoney",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass:
                                "ipd-form-item-half ipd-form-item-right",
                              attrs: {
                                label: "Chuyển khoản",
                                prop: "transferMoney",
                              },
                            },
                            [
                              _c("el-currency-input", {
                                attrs: {
                                  options: _vm.currencyOption,
                                  placeholder: "Nhập tiền chuyển khoản",
                                },
                                model: {
                                  value: _vm.transferMoney,
                                  callback: function ($$v) {
                                    _vm.transferMoney = $$v
                                  },
                                  expression: "transferMoney",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "ipd-form-row" },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "ipd-form-item-half",
                              attrs: {
                                label: "Người thanh toán",
                                prop: "parentPay",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "Phụ huynh học sinh" },
                                model: {
                                  value: _vm.paymentData.parentPay,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.paymentData, "parentPay", $$v)
                                  },
                                  expression: "paymentData.parentPay",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass:
                                "ipd-form-item-half ipd-form-item-right",
                              attrs: {
                                label: "Ngày thanh toán",
                                prop: "datePayment",
                              },
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  type: "date",
                                  clearable: false,
                                  "value-format": "yyyy-MM-dd",
                                  format: "dd-MM-yyyy",
                                  placeholder: "Chọn ngày",
                                  "picker-options": _vm.pickerOptions,
                                },
                                model: {
                                  value: _vm.paymentData.datePayment,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.paymentData,
                                      "datePayment",
                                      $$v
                                    )
                                  },
                                  expression: "paymentData.datePayment",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "ipd-form-item-radio-button",
                          attrs: {
                            label: "Tiền thừa thiếu",
                            prop: "transferMoneyType",
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              staticClass: "ipd-radio-buttons",
                              attrs: { size: "medium" },
                              model: {
                                value: _vm.paymentData.transferMoneyType,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.paymentData,
                                    "transferMoneyType",
                                    $$v
                                  )
                                },
                                expression: "paymentData.transferMoneyType",
                              },
                            },
                            [
                              _c(
                                "el-radio-button",
                                { attrs: { label: "MONEY_WALLET" } },
                                [_vm._v("Không chuyển")]
                              ),
                              _c(
                                "el-radio-button",
                                { attrs: { label: "MONEY_MONTH" } },
                                [_vm._v("Sang phiếu thu sau")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Mô tả", prop: "noteHistory" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "Nhập mô tả" },
                            model: {
                              value: _vm.paymentData.noteHistory,
                              callback: function ($$v) {
                                _vm.$set(_vm.paymentData, "noteHistory", $$v)
                              },
                              expression: "paymentData.noteHistory",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _vm.isActivatedAccount
                            ? _c(
                                "el-checkbox",
                                {
                                  model: {
                                    value: _vm.paymentData.statusSendNotify,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.paymentData,
                                        "statusSendNotify",
                                        $$v
                                      )
                                    },
                                    expression: "paymentData.statusSendNotify",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              Gửi thông báo thanh toán trên App\n            "
                                  ),
                                ]
                              )
                            : _c(
                                "span",
                                { staticStyle: { color: "#d13b93" } },
                                [
                                  _vm._v(
                                    "\n              Tài khoản chưa được kích hoạt, không thể gửi thông báo thanh toán App\n            "
                                  ),
                                ]
                              ),
                        ],
                        1
                      ),
                      _vm.checkPermission([
                        "electronic-invoice-create-issued",
                        "electronic-invoice-create-draft",
                      ])
                        ? _c(
                            "el-form-item",
                            [
                              _c(
                                "el-checkbox",
                                {
                                  model: {
                                    value: _vm.paymentData.draftInvoice,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.paymentData,
                                        "draftInvoice",
                                        $$v
                                      )
                                    },
                                    expression: "paymentData.draftInvoice",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              Lập hoá đơn nháp trên Onekids\n            "
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("InvoiceCreateDialog", {
        attrs: {
          isOpenInvoiceCreateDialog: _vm.invoiceCreateDialogVisible,
          initialItems: _vm.invoiceInitialItems,
          kidCode: _vm.invoiceData.studentCode,
          orderKidCode: _vm.invoiceData.invoiceCode,
        },
        on: {
          "update:isOpenInvoiceCreateDialog": function ($event) {
            _vm.invoiceCreateDialogVisible = $event
          },
          "update:is-open-invoice-create-dialog": function ($event) {
            _vm.invoiceCreateDialogVisible = $event
          },
          "dialog-close": _vm.handleCloseInvoiceCreateDialog,
          back: _vm.handleCloseInvoiceCreateDialog,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }